export const BackgroundJobProgressFragment = gql`
  fragment BackgroundJobProgressFragment on BackgroundJob {
    id
    usingLoader
    type
    status
    isAcknowledged
    isInTerminalStatus
    viewId
    viewName
    recordTypeId
    recordTypeName
    totalCount
    processedCount
    successCount
    errorCount
  }
`
